<template>
  <div
    class="html_beyondTheMoment"
    ref="html_beyondTheMoment"
    v-if="datas.objectInfo && datas.objectInfo.length == 1"
  >
    <div class="main">
      <div class="left-box">
        <AbPlayerImg
          v-for="item in datas.objectInfo"
          :key="item.playerId"
          :playerImg="item.playerInfos[0].profilePicture"
          :playerNum="item.playerInfos[0].shirtNumber * 1"
          :playerName="item.playerInfos[0].playerName"
          :countryImg="item.teamLogo"
          :countryName="item.teamName"
          :width="'9.72vw'"
        ></AbPlayerImg>
      </div>
      <div class="right-box">
        <HorBarItemTextUp
          v-for="rowData in rowDataList"
          :key="rowData.name"
          :data="rowData"
        ></HorBarItemTextUp>
      </div>
    </div>
  </div>
</template>

<script>
// 游泳 单人 超越时刻
import AbPlayerImg from '../components/PlayerImg'
import HorBarItemTextUp from '../components/HorBarItem_textUp'
// import htmlDomToImage_base64_data_mixin from '@mixins/htmlDomToImage_base64_data'
export default {
  name: 'html_beyondTheMoment',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {
    AbPlayerImg,
    HorBarItemTextUp,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
  data() {
    return {}
  },
  created() {
    // 模拟数据
    console.debug(this.datas)
  },
  updated() {
    console.debug(`更新： ${this.datas}`)
  },
  computed: {
    rowDataList() {
      return this.datas.data.dataList && this.datas.data.dataList.length > 0
        ? this.datas.data.dataList.map((item) => {
            let valPer = (1 - (item.rankNum - 1) / 8).toFixed(2) * 100
            return {
              nth: item.rankNumShow,
              name: item.showName,
              valPer,
            }
          })
        : null
    },
  },
  methods: {
    _valFormatHandler(val, text, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (text) {
          data = `${text}: ${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_beyondTheMoment {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    width: 80%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);

    .left-box {
      font-size: 0.972vw;
    }
    .right-box {
      position: relative;
      margin-left: 2.083vw;
      height: 11.8vw;
      width: calc(100% - 9.72vw);
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
    }
  }
}
</style>
